module.exports = __webpack_public_path__ + "static/img/form.80703570.svg";